export const moveToFolderNewFolderText = "Odc";
export const moveToArchiveMbxFolderNewFolderText = "Pdc";
export const searchFolder = "Qdc";
export const searchArchiveFolder = "Rdc";
export const moveToSearchSharedFolder = "Sdc";
export const moveToFolderCreateNewText = "Tdc";
export const moveToArchiveMbxFolderCreateNewText = "Udc";
export const rootFolderString = "Vdc";
export default {moveToFolderNewFolderText,moveToArchiveMbxFolderNewFolderText,searchFolder,searchArchiveFolder,moveToSearchSharedFolder,moveToFolderCreateNewText,moveToArchiveMbxFolderCreateNewText,rootFolderString};